module.exports = __webpack_public_path__ + "partylineManage/img/Kiosk.68670826.png";